module.exports = __webpack_public_path__ + "static/media/landing-boost-reviews.74ed831f.png";